import type { JSX } from 'react';

import { Button } from '@/components/ui/button';

interface ActivityEmptyStateProps {
  search: string;
  onClearSearch: () => void;
}

const ActivityEmptyState = ({ search, onClearSearch }: ActivityEmptyStateProps): JSX.Element => (
  <div className="flex flex-col items-center gap-2 py-12 text-center">
    <p className="m-0 text-sm text-text-muted font-body">
      {search
        ? `No hay resultados para "${search}" con los filtros seleccionados.`
        : 'No hay actividad para los filtros seleccionados.'}
    </p>
    {search ? (
      <Button variant="ghost" size="sm" onClick={onClearSearch}>
        Limpiar búsqueda
      </Button>
    ) : null}
  </div>
);

export default ActivityEmptyState;
